import { useMutation, useQueryClient } from "react-query";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { AlarmSetpoint } from "./Common";
import { keys } from "./Keys";

export type AcknowledgeAlarmParameters = {
    groupID: number;
} & BaseUseMutationParameters<void, AlarmSetpoint>;

export function useAcknowledgeAlarm({
    groupID,
    onError,
    onSuccess
}: AcknowledgeAlarmParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, AlarmSetpoint>(
        (setpoint) => {
            return AlarmSetpointsDataService.acknowledgeAlarm(groupID, setpoint.tagID, setpoint.id);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, _error, _item, _context) => {
                queryClient.invalidateQueries(keys.all);
            }
        }
    );
}
